const View = require("presto-ui").baseView;

class Project extends View {

	constructor(props, children, state) {
		super(props, children, state);
		this.shouldCacheScreen = false;

		this.setIds(['Content']);

		this.style_Register = {
			onClick: this.onClickRegister.bind(this)
		}

		this.style_Forum = {
			onClick: this.onClickForum.bind(this)
		}

		this.style_Group_5 = {
			onClick: this.onClickHome.bind(this)
		}

		this.style_Button = {
			onClick: this.onClickSubmit.bind(this)
		}
	}

	onClickHome(){
		var cmd = this.cmd({id : this.idSet.Content, visibility: "gone"});
		Android.runInUI(cmd,null);
		document.getElementById("content").scrollTo(0,0);

		if (window.__WIDTH <=600)
			window.__duiShowScreen(null,{screen:"MobileHome2"});
		else
			window.__duiShowScreen(null,{screen:"Home2"});
	}

	onClickRegister() {
		window.open("https://form.jotform.co/73251234628858",'_blank');
	}

	onClickForum() {
		window.open("https://muut.com/purescript-presto",'_blank');
	}

	onClickSubmit() {
		window.open("https://docs.google.com/forms/d/e/1FAIpQLSfB2DXrYR7RHLdbdEJAE9h5WVb3LV3tIh3aC74A8IwXIF1WZw/viewform",'_blank');
	}

}

module.exports = Project;



// WEBPACK FOOTER //
// ./controller/pages/Main/Project.js